import { Badge, makeStyles } from '@material-ui/core';
import {
  activeChatSideSelector,
  totalChatsBotSelector,
  totalChatsOnHoldSelector,
  totalChatsRequestSelector,
} from '@src/selectors/chats';
import { ChatSideType } from '@src/types/chats';
import { useSelector } from 'react-redux';

const MAX_COUNT = 999;

export const BadgeCountMsgs: React.FC<
  React.PropsWithChildren<{
    type: ChatSideType;
  }>
> = ({ type, children }) => {
  const classes = useStyles();

  const activeChatSide = useSelector(activeChatSideSelector);

  const totalOnHold = useSelector(totalChatsOnHoldSelector);
  const totalRequest = useSelector(totalChatsRequestSelector);
  const totalBot = useSelector(totalChatsBotSelector);

  let totalUnseenEvents = totalOnHold;
  if (type === ChatSideType.REQUEST) totalUnseenEvents = totalRequest;
  if (type === ChatSideType.BOT) totalUnseenEvents = totalBot;

  return (
    <Badge
      classes={classes}
      badgeContent={
        totalUnseenEvents > MAX_COUNT ? `+${MAX_COUNT}` : totalUnseenEvents
      }
      max={MAX_COUNT}
      className={
        activeChatSide === type ? classes.color : classes.colorSelected
      }
    >
      {children}
    </Badge>
  );
};

const useStyles = makeStyles(theme => ({
  badge: {
    top: '1px',
    right: '-4px',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontStyle: 'SemiBold',
    fontSize: '10px',
    leadingTrim: 'NONE',
    lineHeight: '3.98px',
    letterSpacing: '0px',
    textAlign: 'center',
    padding: '0 2px',
  },
  color: {
    '& .MuiBadge-badge': {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
    },
  },
  colorSelected: {
    '& .MuiBadge-badge': {
      color: 'white',
      backgroundColor: '#656773',
    },
  },
}));

export default BadgeCountMsgs;
